module.exports = __webpack_public_path__ + "static/media/headerLogo.603e037b.png";